import React from 'react';
import Loading from '../../../shared/Loading/Loading';

const DynamicTable = ({ headerGroups, getTableBodyProps, page, prepareRow, globalFilter, setGlobalFilter, loading, previousPage, canPreviousPage, pageIndex, pageOptions, nextPage, canNextPage }) => {
  return (
    <>
      <div className="pt-2 relative mx-auto text-gray-600">
        <input
          type="text"
          value={globalFilter || ""}
          onChange={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search Project...."
          className="border-2 border-gray-300 bg-white h-10 px-5 pr-16 rounded-lg text-sm focus:outline-none"
        />
        <button type="submit" className="absolute right-0 top-0 mt-5 mr-4">
          <svg
            className="text-gray-600 h-4 w-4 fill-current"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 56.966 56.966"
            style={{ enableBackground: "new 0 0 56.966 56.966" }}
            xmlSpace="preserve"
            width="512px"
            height="512px"
          >
            <path d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17s-17-7.626-17-17S14.61,6,23.984,6z" />
          </svg>
        </button>
      </div>

      {/* Table */}
      {loading ? (
        <Loading />
      ) : (
        <div className="overflow-x-auto">
          <div className="min-w-screen  flex items-center justify-center  font-sans overflow-hidden">
            <div className="w-full">
              <div className="bg-white shadow-md rounded-md my-6">
                <table className="min-w-max w-full table-auto">
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr
                        className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal"
                        {...headerGroup.getHeaderGroupProps()}
                      >
                        {headerGroup.headers.map((column) => (
                          <th
                            className="py-3 px-6 text-left"
                            {...column.getHeaderProps(
                              column.getSortByToggleProps()
                            )}
                          >
                            {column.render("Header")}
                            <span>
                              {column.isSorted
                                ? column.isSortedDesc
                                  ? " 🔽"
                                  : " 🔼"
                                : "🔽"}
                            </span>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody
                    className="text-gray-600 text-sm font-light"
                    {...getTableBodyProps()}
                  >
                    {page.map((row) => {
                      prepareRow(row);
                      return (
                        <tr
                          className="border-b border-gray-200 hover:bg-gray-100"
                          {...row.getRowProps()}
                        >
                          {row.cells.map((cell) => (
                            <td
                              className="py-3 px-6 text-left whitespace-nowrap"
                              {...cell.getCellProps()}
                            >
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Pagination */}
      <div className="flex flex-col md:flex-row items-center justify-center">
  <button
    onClick={() => previousPage()}
    disabled={!canPreviousPage}
    className={`${
      !canPreviousPage ? "opacity-50 cursor-not-allowed" : ""
    } bg-slate-400 hover:bg-amber-500 text-white py-2 px-4 rounded-l mb-2 md:mb-0 md:mr-2`}
  >
    Previous
  </button>
  <span className="px-4 mb-2 md:mb-0">
    Page{" "}
    <strong>
      {pageIndex + 1} of {pageOptions.length}
    </strong>
  </span>
  <button
    onClick={() => nextPage()}
    disabled={!canNextPage}
    className={`${
      !canNextPage
        ? "opacity-50 cursor-not-allowed"
        : "bg-yellow-500 hover:bg-yellow-600"
    } text-white py-2 px-4 rounded-r`}
    style={{ backgroundColor: canNextPage ? "" : "#DF7E07" }}
  >
    Next
  </button>
</div>

    </>
  );
};

export default DynamicTable;
